var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOp2Mise2Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.05 52.9971C27.66 52.9971 27.28 52.8471 26.99 52.5571C26.41 51.9671 26.41 51.0171 27 50.4371C28.62 48.8371 30.24 47.2671 31.84 45.7171C43.22 34.7271 53.04 25.2471 48.37 13.7871C41.22 -3.02292 11.81 4.91708 11.51 5.00708C10.71 5.22708 9.87999 4.75708 9.65999 3.96708C9.43999 3.16708 9.90999 2.34708 10.7 2.11708C12.01 1.74708 42.95 -6.60292 51.13 12.6371C56.58 25.9971 45.57 36.6271 33.92 47.8771C32.33 49.4071 30.72 50.9671 29.11 52.5671C28.81 52.8471 28.43 52.9971 28.05 52.9971Z",
    fill: "url(#paint0_linear_4_6258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09 53.3771C7.75 53.3771 7.4 53.2571 7.12 53.0271C6.49 52.4871 6.40999 51.5471 6.93999 50.9171C11.98 44.9671 17.18 39.7271 21.76 35.0971C27.09 29.7171 33.72 23.0371 33.08 21.2171C31.38 18.2771 21.15 19.5771 14.38 21.4471C13.58 21.6671 12.75 21.1971 12.53 20.3971C12.31 19.5971 12.78 18.7771 13.57 18.5471C16.7 17.6771 32.46 13.6771 35.75 19.8571L35.8 19.9571C37.39 23.5771 32.31 28.7071 23.89 37.1971C19.34 41.7871 14.19 46.9771 9.23 52.8371C8.94 53.1971 8.52 53.3771 8.09 53.3771Z",
    fill: "url(#paint1_linear_4_6258)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.56 69.697H2.44C1.61 69.697 0.940002 69.027 0.940002 68.197C0.940002 67.367 1.61 66.697 2.44 66.697H49.56C50.39 66.697 51.06 67.367 51.06 68.197C51.06 69.027 50.38 69.697 49.56 69.697Z",
    fill: "url(#paint2_linear_4_6258)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.69 44.4571C21.05 47.0771 18.31 49.7871 15.68 52.5371C15.39 52.8471 14.99 52.9971 14.6 52.9971C14.23 52.9971 13.85 52.8571 13.56 52.5771C12.96 52.0071 12.94 51.0571 13.51 50.4571C16.17 47.6871 18.91 44.9571 21.57 42.3271C31.69 32.2871 41.25 22.7971 37.83 18.1971C32.88 10.5571 14.2 16.0371 6.77999 19.0171C6.81999 18.8171 6.84998 18.5971 6.84998 18.3871C6.84998 17.4971 6.45998 16.7171 5.84998 16.1671C10.26 14.4371 33.48 5.9671 40.29 16.4871C45.22 23.0971 35.24 32.9871 23.69 44.4571ZM5.85998 16.1571C5.32998 15.6771 4.62999 15.3771 3.85999 15.3771C2.19999 15.3771 0.859985 16.7171 0.859985 18.3771C0.859985 20.0371 2.19999 21.3771 3.85999 21.3771C5.29999 21.3771 6.49999 20.3671 6.78999 19.0071C6.82999 18.8071 6.85998 18.5871 6.85998 18.3771C6.85998 17.4871 6.46998 16.7071 5.85998 16.1571Z",
    fill: "url(#paint3_linear_4_6258)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 52.2471L21.81 52.5971C21.52 52.8671 21.15 52.9971 20.79 52.9971C20.39 52.9971 19.99 52.8371 19.69 52.5171C19.13 51.9071 19.16 50.9571 19.77 50.3971L20.14 50.0471C34.29 36.9071 47.66 24.4871 43.04 15.4771C37.08 4.86713 15.88 10.0871 10.91 11.4871C11.02 11.1671 11.09 10.8371 11.09 10.4871C11.09 9.73713 10.8 9.05713 10.34 8.52713C16.25 6.86713 38.64 1.53713 45.68 14.0571C51.36 25.1471 37.19 38.3071 22.18 52.2471ZM10.35 8.52713C9.80001 7.89713 9.00001 7.48713 8.10001 7.48713C6.44001 7.48713 5.10001 8.82713 5.10001 10.4871C5.10001 12.1471 6.44001 13.4871 8.10001 13.4871C9.40001 13.4871 10.5 12.6471 10.92 11.4871C11.03 11.1671 11.1 10.8371 11.1 10.4871C11.09 9.73713 10.81 9.05713 10.35 8.52713Z",
    fill: "url(#paint4_linear_4_6258)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.47 62.5171C53.47 63.0671 53.63 63.5771 53.89 64.0171H6.23001C5.40001 64.0171 4.73001 63.3471 4.73001 62.5171C4.73001 61.6871 5.40001 61.0171 6.23001 61.0171H53.89C53.63 61.4571 53.47 61.9671 53.47 62.5171ZM56.47 59.5171C55.36 59.5171 54.41 60.1271 53.89 61.0171C53.63 61.4571 53.47 61.9671 53.47 62.5171C53.47 63.0671 53.63 63.5771 53.89 64.0171C54.41 64.9071 55.37 65.5171 56.47 65.5171C58.13 65.5171 59.47 64.1771 59.47 62.5171C59.47 60.8571 58.13 59.5171 56.47 59.5171Z",
    fill: "url(#paint5_linear_4_6258)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.56 56.9871C46.56 57.5371 46.72 58.0471 46.98 58.4871H1.5C0.67 58.4871 0 57.8171 0 56.9871C0 56.1571 0.67 55.4871 1.5 55.4871H46.98C46.71 55.9371 46.56 56.4371 46.56 56.9871ZM49.56 53.9871C48.45 53.9871 47.5 54.5971 46.98 55.4871C46.72 55.9271 46.56 56.4371 46.56 56.9871C46.56 57.5371 46.72 58.0471 46.98 58.4871C47.5 59.3771 48.46 59.9871 49.56 59.9871C51.22 59.9871 52.56 58.6471 52.56 56.9871C52.56 55.3371 51.21 53.9871 49.56 53.9871Z",
    fill: "url(#paint6_linear_4_6258)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_6258",
    x1: 31.0771,
    y1: 52.9948,
    x2: 31.0771,
    y2: -0.00292199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_6258",
    x1: 21.3493,
    y1: 53.3737,
    x2: 21.3493,
    y2: 16.4744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_6258",
    x1: 0.935102,
    y1: 68.1997,
    x2: 51.0557,
    y2: 68.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_6258",
    x1: 21.2205,
    y1: 52.9948,
    x2: 21.2205,
    y2: 11.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_6258",
    x1: 26.0292,
    y1: 52.9948,
    x2: 26.0292,
    y2: 5.97753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BDCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_6258",
    x1: 4.72421,
    y1: 62.5158,
    x2: 62.6482,
    y2: 62.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_6258",
    x1: -0.0127,
    y1: 56.9895,
    x2: 57.1249,
    y2: 56.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177269"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp2Mise2Logo);
export default __webpack_public_path__ + "static/media/op2mise-2-logo.1c493f323f2696e2679371c57b051729.svg";
export { ForwardRef as ReactComponent };